import * as React from "react";

import { PopoverTrigger } from "@v1/components/designSystem/shadcn/core/popover";

export const ComboboxTrigger: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <PopoverTrigger asChild>{children}</PopoverTrigger>;
};
